export default __webpack_public_path__ + "4d1da1e6e4662e42ce2a87814e2e6e63.png";